import img1 from "./Team photos/GARIMA.png";
import img2 from "./Team photos/TEJA.png";
import img3 from "./Team photos/ABHIRAM.png";
import img4 from "./Team photos/RIYA.png";
import img5 from "./Team photos/ASHISH.png";
import img6 from "./Team photos/YESWANTH.png";
import img7 from "./Team photos/SIDDHARTH.png";
import img8 from "./Team photos/TANMAY.png";
import img9 from "./Team photos/TUSHARR.png";
import img10 from "./Team photos/UDDIPTA.png";
import img11 from "./Team photos/MANISH.png";
import img12 from "./Team photos/DIVYA.png";
//import img13 from "./Team photos/Ajay.png";

const team=[
    {id: 1,name: "Garima",role: "Licensee",image: img1,linkedin: "https://www.linkedin.com/in/garima-bansal-9416a4335/"},
    {id: 2,name: "Teja",role: "Co-Licensee & Content Head",image: img2,linkedin: "https://www.linkedin.com/in/teja-shanmuka/"},
    {id: 3,name: "Abhiram",role: "Web Ops Head",image: img3,linkedin: "https://www.linkedin.com/in/p-s-abhiram/"},
    {id: 4,name: "Riya",role: "Speakers Head",image: img4,linkedin: "https://www.linkedin.com/in/riya-kumari-723055316/"},
    {id: 5,name: "Ashish",role: "Speakers Core",image: img5,linkedin: "https://www.linkedin.com/in/ashish-bugalia-771bb8246/"},
    {id: 6,name: "Yeswanth",role: "Marketing Head",image: img6,linkedin: "https://www.linkedin.com/in/yeswanth-kumar-nykr/"},
    {id: 7,name: "Siddharth",role: "PR & Media Head",image: img7,linkedin: "https://www.linkedin.com/in/siddharth-morwal-275055387/"},
    {id: 8,name: "Tanmay",role: "PR & Media Core",image: img8,linkedin: "https://www.linkedin.com/in/tanmay-verma-374876382/"},
    {id: 9,name: "Tusharr",role: "Creatives Head",image: img9,linkedin: "https://www.linkedin.com/in/tushar-raj-prasad-724950321/"},
    {id: 10,name: "Uddipta",role: "Creatives Core",image: img10,linkedin: "https://www.linkedin.com/in/uddiptabhaskarsarma/"},
    {id: 11,name: "Manish",role: "Events Head",image: img11,linkedin: "https://www.linkedin.com/in/manish-sharma-524741319/"},
    {id: 12,name: "Divya",role: "Events Core",image: img12,linkedin: "https://www.linkedin.com/in/divya-preeti-b382a7384/"},
   // {id: 13,name: "Ajay",role: "Events Core",image: img13,linkedin: ""},
];

export default team;